import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button } from "@mui/material";
import { Field } from "components";
import { INewsletterForm, newsLetterFormValidation } from "./NewsletterForm.config";

interface INewsletterFormProps {
  onCompletedForm: (values: INewsletterForm) => void;
};

export const NewsletterForm = (props: INewsletterFormProps) => {

  const { onCompletedForm } = props;

  const methods = useForm<INewsletterForm>({
    resolver: zodResolver(newsLetterFormValidation),
  });

  const onSubmitHandler: SubmitHandler<INewsletterForm> = (values: INewsletterForm) => {
    onCompletedForm(values);
  };

  return (
    <div>
      <FormProvider {...methods}>
        <Box
          component='form'
          noValidate
          autoComplete='off'
          onSubmit={methods.handleSubmit(onSubmitHandler)}
        >
          <Field.TextField
            name={"name"}
            label={"Nombre"}
            fieldColor={"black"}
          />
          <Field.TextField
            name={"surname"}
            label={"Apellido"}
            fieldColor={"black"}
          />
          <Field.TextField
            name={"email"}
            label={"Correo electrónico"}
            fieldColor={"black"}
          />
          <Button fullWidth type="submit">Unirme</Button>
        </Box>
      </FormProvider>
    </div>
  );
};